module.exports = __webpack_public_path__ + "img/aw.aw9f9a1e1.svg";